"use client"

import Link from "next/link"

interface InlineLegalNoticeProps {
  prefix?: string
  className?: string
  linkClassName?: string
}

export function InlineLegalNotice({
  prefix = "By continuing, you agree to our",
  className = "text-xs text-black/60",
  linkClassName = "underline underline-offset-2 hover:opacity-80",
}: InlineLegalNoticeProps) {
  return (
    <p className={className}>
      {prefix}{" "}
      <Link href="/terms" className={linkClassName}>
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link href="/privacy" className={linkClassName}>
        Privacy Policy
      </Link>
      .
    </p>
  )
}

interface FooterLegalLinksProps {
  className?: string
  linkClassName?: string
}

export function FooterLegalLinks({
  className = "text-xs text-black/60",
  linkClassName = "underline underline-offset-2 hover:opacity-80",
}: FooterLegalLinksProps) {
  return (
    <div className={className}>
      <Link href="/privacy" className={linkClassName}>
        Privacy Policy
      </Link>
      <span className="mx-2">·</span>
      <Link href="/terms" className={linkClassName}>
        Terms & Conditions
      </Link>
    </div>
  )
}
